import { render, staticRenderFns } from "./articleAndQa.vue?vue&type=template&id=64b564a4&scoped=true&"
import script from "./articleAndQa.vue?vue&type=script&lang=js&"
export * from "./articleAndQa.vue?vue&type=script&lang=js&"
import style0 from "./articleAndQa.vue?vue&type=style&index=0&id=64b564a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b564a4",
  null
  
)

export default component.exports